import React from 'react';
import { InputGroup, InputLeftElement, Box, ResponsiveValue } from '@chakra-ui/react';
import tinycolor from 'tinycolor2';

import { CustomInput } from '../atoms/ContactUsForm/CustomInput';
import { CustomIcon } from '../atoms/CustomIcon'; // Icon Atom

interface InputWithIconProps {
  placeholder?: string;
  width?: ResponsiveValue<string>;
  height?: ResponsiveValue<string>;
  // iconSize?: ResponsiveValue<string>;
  iconColor?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  placeholderFontFamily?: string;
  placeholderFontSize?: ResponsiveValue<string>;
  placeholderFontWeight?: string;
  InputIcon: React.ElementType;
  [key: string]: any;
  px?: ResponsiveValue<string>;
  searchBarBgColor?: string;
  searchBarTextColor?: string;
  placeholderColor?: string;
  borderColor?: string;
  borderRadius: string;
}

export const InputWithIcon: React.FC<InputWithIconProps> = ({
  placeholder,
  width = '100%',
  height = '48px',
  // iconSize = { base: '20px', md: '24px', lg: '28px' },
  searchBarBgColor,
  searchBarTextColor = 'white',
  placeholderColor = 'white',
  placeholderFontWeight,
  iconColor = tinycolor(searchBarTextColor).lighten(30).toString(),
  onChange,
  value,
  placeholderFontFamily = 'Arial, sans-serif',
  placeholderFontSize = '16px',
  InputIcon,
  px,
  borderColor,
  borderRadius,
}) => {
  return (
    <Box width={width} px={px} id="inputwithicon">
      <InputGroup>
        {/* Left aligned search icon */}
        <InputLeftElement
          pointerEvents="none"
          height={height}
          display="flex"
          alignItems="center"
          justifyContent="center"
          top="50%"
          transform="translateY(-50%)"
        >
          <CustomIcon
            icon={InputIcon}
            color={iconColor}
            sx={{
              width: { base: '18px', md: '20px', lg: '22px' },
              height: { base: '18px', md: '20px', lg: '22px' },

              '@media (orientation: landscape) and (max-width: 768px)': {
                width: '24px',
                height: '24px',
              },
            }}
          />
        </InputLeftElement>

        {/* Input component */}
        <CustomInput
          shadow="md"
          bgColor={searchBarBgColor}
          inputTextColor={searchBarTextColor}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          height={height}
          paddingLeft="50px"
          _placeholder={{
            fontFamily: placeholderFontFamily,
            fontSize: placeholderFontSize,
          }}
          fontSize="xl"
          placeholderColor={placeholderColor}
          placeholderFontSize={placeholderFontSize}
          placeholderFontWeight={placeholderFontWeight}
          borderColor={borderColor}
          borderRadius={borderRadius}
          borderWidth="2px"
        />
      </InputGroup>
    </Box>
  );
};
